import integrationId from './integrationId';

export enum KEYS {
  widgetIsOpen = 'isOpen',
  isResponsesGroupHide = 'isResponsesGroupHide',
  currentMessage = 'currentMessage',
  isPDCFormSubmitted = 'isPDCFormSubmitted',
  routerHistory = 'routerHistory',
  isChatbotOpeningSignalSent = 'isChatbotOpeningSignalSent',
}

const prefix = '-dancecard-leadnurturing-';

function addPrefix(key) {
  return integrationId + prefix + key;
}

let fallbackStorage = {
  isOpen: null,
  isResponsesGroupHide: false,
  currentMessage: null,
  emailRequestedMessagesIds: null,
  routerHistory: null,
  isChatbotOpeningSignalSent: null,
};

// TODO: edge cases & typing
export function setDataToSessionStorage(key: KEYS, data) {
  try {
    const dataToSave = JSON.stringify(data);
    sessionStorage.setItem(addPrefix(key), dataToSave);
  } catch (err) {
    fallbackStorage[key] = data;
  }
}

export function getDataFromSessionStorage(key: KEYS) {
  try {
    const data = sessionStorage.getItem(addPrefix(key)) as string;
    return JSON.parse(data);
  } catch (err) {
    return fallbackStorage[key];
  }
}

export function removeItemFromSessionStorage(key: KEYS) {
  try {
    sessionStorage.removeItem(addPrefix(key));
  } catch (err) {
    fallbackStorage[key] = null;
  }
}
